module.exports = __webpack_public_path__ + "img/altitude.3183c7e1.svg";